import React from "react";
import { useNavigate } from "react-router-dom"; // ← added
import "./Categories.css";

// Import images
import HomeLightingImage from "../../assets/Home Lighting.png.webp";
import IndustrialLightingImage from "../../assets/Industrial Lighting.png.webp";
import CommercialLightingImage from "../../assets/Commercial Lighting.png.webp";
import StreetLightingImage from "../../assets/Street Lighting.png.webp";

const Categories: React.FC = () => {
  const navigate = useNavigate();

  // Helper function to navigate with category pre-selected
  const handleLearnMore = (category: string) => {
    navigate(`/products?categories=${encodeURIComponent(category)}`);
  };

  return (
    <div className="categories-container">
      {/* Left Column */}
      <div className="categories-right">
        {/* Home Lighting */}
        <div className="category">
          <img loading="lazy" decoding="async"
            className="category-image"
            src={HomeLightingImage}
            alt="Home Lighting"
          />
          <div className="category-content">
            <p className="category-subtitle">Comfort for everyday living</p>
            <h2 className="category-title">Home Lighting</h2>
            <button
              className="category-button"
              onClick={() => handleLearnMore("Home Lighting")}
            >
              Learn More
            </button>
          </div>
        </div>

        {/* Commercial Lighting */}
        <div className="category">
          <img loading="lazy" decoding="async"
            className="category-image"
            src={CommercialLightingImage}
            alt="Commercial Lighting"
          />
          <div className="category-content">
            <p className="category-subtitle">Lighting for productivity</p>
            <h2 className="category-title">Commercial Lighting</h2>
            <button
              className="category-button"
              onClick={() => handleLearnMore("Commercial Lighting")}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className="categories-right">
        {/* Industrial Lighting */}
        <div className="category">
          <img loading="lazy" decoding="async"
            className="category-image"
            src={IndustrialLightingImage}
            alt="Industrial Lighting"
          />
          <div className="category-content">
            <p className="category-subtitle">Brightening work environments</p>
            <h2 className="category-title">Industrial Lighting</h2>
            <button
              className="category-button"
              onClick={() => handleLearnMore("Industrial Lighting")}
            >
              Learn More
            </button>
          </div>
        </div>

        {/* Street Lighting */}
        <div className="category">
          <img loading="lazy" decoding="async"
            className="category-image"
            src={StreetLightingImage}
            alt="Street Lighting"
          />
          <div className="category-content">
            <p className="category-subtitle">Lighting safer streets</p>
            <h2 className="category-title">Street Lighting</h2>
            <button
              className="category-button"
              onClick={() => handleLearnMore("Street Lighting")}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
